import { Card, Typography } from 'antd';
import { ChangePasswordForm } from '@ubus/shared';
import { useTranslation } from 'react-i18next';

const { Title, Paragraph } = Typography;

function AccountSecurity() {
  const { t } = useTranslation();

  return (
    <div style={{ maxWidth: 560, margin: '0 auto', padding: '24px 16px' }}>
      <Title level={3} style={{ marginBottom: 8 }}>
        {t('account.title')}
      </Title>
      <Paragraph type="secondary">
        {t('account.subtitle')}
      </Paragraph>
      <Card>
        <ChangePasswordForm
          primaryColor="#ea580c"
          labels={{
            currentPassword: t('account.currentPassword'),
            newPassword: t('account.newPassword'),
            confirmPassword: t('account.confirmPassword'),
            enterCurrent: t('account.enterCurrent'),
            enterNew: t('account.enterNew'),
            confirmNew: t('account.confirmNew'),
            mismatch: t('account.mismatch'),
            tooShort: t('account.tooShort'),
            updated: t('account.updated'),
            submit: t('account.submit'),
          }}
        />
      </Card>
    </div>
  );
}

export default AccountSecurity;
